import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  COACH_INDEX,
  CLUB_COACH_INDEX,
  UPDATE_COACH_INDEX,
  TOGGLE_COACH_ACTIVATION,
  UPDATE_COACH_ROLE,
  DELETE_COACH,
  CREATE_COACH,
  DELETE_CLUB_COACH,
  CREATE_CLUB_COACH,
  SHOW_CLUB_COACH,
  UPDATE_CLUB_COACH,
  COACH_UPLOAD_IMAGE,
  UPLOAD_IMAGE_POST,
  CONTACT_COACH_BY_EMAIL,
  DELETE_COACH_IMAGES,
  GET_COLLEGE_COACH
} from "@/utils/api-url";

class Coach extends Base {
  constructor(params = {}) {
    super(params);

    this.lastLogin =
      (params["coachId"] && params["coachId"]["lastLogin"]) ||
      this.lastLogin ||
      "";
    this.key = params["_id"] || this.Id || this.id || this.key || "";
    this.id = params["_id"] || params["id"];
    this.name = params["coachname"] || this.coachname || this.name || "";
    this.coachname = params["coachname"] || this.coachname || "";
    this.position =
      params["position"] ||
      (params["position"] && params["position"]["name"]) ||
      this.position ||
      "";
    this.email = params["email"] || this.email || "";
    this.staffPhone = params["staffphone"] || this.staffPhone || "";
    this.isActive = params["isActive"] || this.isActive;
    this.activeStatus = this.isActive ? "Active" : "Inactive";
    this.status =
      this.coachId && this.coachId["lastLogin"]
        ? this.activeStatus
        : "Not Logged In";
    this.badgeClass = `${this.status.toLowerCase()}-badge`;
    this.deactivatedBy = params["byWhom"] || this.byWhom || "";
    this.description = params["description"] || this.description || "";
    this.collegeName =
      (params["CollegeId"] && params["CollegeId"]["collegeName"]) ||
      this.collegeName ||
      "";
    this.jobDescription = `${this.position} at ${this.collegeName}`;
    this.role = params["role"] || this.role || "";
    this.coachId =
      (params["coachId"] && params["coachId"]["_id"]) || this.coachId || "";
    (this.dReason = params["dReason"] || this.dReason || ""),
      (this.collegeId =
        (params["CollegeId"] && params["CollegeId"]["id"]) ||
        this.collegeId ||
        "");
    this.clubId =
      (params["clubId"] && params["clubId"]["_id"]) || this.clubId || "";
    this.role =
      (params["coachId"] && params["coachId"]["role"]) || this.role || "";
    this.clubName =
      (params["clubId"] && params["clubId"]["clubName"]) || this.clubName || "";
  }

  static resourceName() {
    return "coach";
  }

  static index(params) {
    const { resourceType } = params;
    params.resourceType = null;

    const profileId = this.profileId();
    if (resourceType !== "clubcoach")
      return apiDispatcher(COACH_INDEX(params, profileId, resourceType));
    return apiDispatcher(CLUB_COACH_INDEX(params, profileId, resourceType));
  }

  static update(params) {
    const profileId = this.profileId();
    return apiDispatcher(UPDATE_COACH_INDEX(params, profileId));
  }

  static toggleActivation(params) {
    const profileId = this.profileId();
    return apiDispatcher(TOGGLE_COACH_ACTIVATION(params, profileId));
  }

  static updateRole(params) {
    const profileId = this.profileId();
    return apiDispatcher(UPDATE_COACH_ROLE(params, profileId));
  }

  static deleteCoach(params) {
    const profileId = this.profileId();
    return apiDispatcher(DELETE_COACH(params, profileId));
  }

  static deleteClubCoach(params) {
    const profileId = this.profileId();
    return apiDispatcher(DELETE_CLUB_COACH(params, profileId));
  }

  static create(params) {
    const profileId = this.profileId();
    return apiDispatcher(CREATE_COACH(params, profileId));
  }

  static createClubCoach(params) {
    const profileId = this.profileId();
    return apiDispatcher(CREATE_CLUB_COACH(params, profileId));
  }

  static getClubCoach(params) {
    const profileId = this.profileId();
    return apiDispatcher(SHOW_CLUB_COACH(params, profileId));
  }

  static getCollegeCoach(params) {
    const profileId = this.profileId();
    return apiDispatcher(GET_COLLEGE_COACH(params, profileId));
  }

  static editClubCoach(params) {
    const profileId = this.profileId();
    return apiDispatcher(UPDATE_CLUB_COACH(params, profileId));
  }

  static uploadImage(params) {
    const id = params.id;
    return apiDispatcher(COACH_UPLOAD_IMAGE(id, params.image));
  }

  static uploadClubCoachImage(params) {
    const id = params.id;
    return apiDispatcher(UPLOAD_IMAGE_POST("clubcoach", id, params.image));
  }

  static contactCoachByMail(data) {
    return apiDispatcher(CONTACT_COACH_BY_EMAIL(data));
  }

  static deleteCoachImages(data) {
    return apiDispatcher(DELETE_COACH_IMAGES(data));
  }

  static coachRoles = [
    {
      label: "College Normal Coach",
      value: "collegeNormalCoach"
    },
    {
      label: "College PROFILE MAINTAINER",
      value: "collegeProfileMaintainer"
    }
  ];

  static validationRules = {
    coachname: [
      { required: true, message: "Please enter coach name", trigger: "blur" }
    ],
    description: [
      { required: false, message: "Please enter description", trigger: "blur" }
    ],
    email: [{ required: true, message: "Please enter email", trigger: "blur" }],
    staffPhone: [
      { required: true, message: "Please enter phone number", trigger: "blur" }
    ],
    position: [
      { required: true, message: "Please enter position", trigger: "blur" }
    ],
    role: [{ required: true, message: "Please enter role", trigger: "blur" }]
  };
}

export default Coach;
